<template>
  <div>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ $t('formError.unknownwError') }}
    </b-alert>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <h4 class="status-title">Status Einladungen</h4>
    <b-table
      :items="items"
      :fields="fields"
      :filter="filter"
      @filtered="onFiltered"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :current-page="currentPage"
      :per-page="perPage"
      responsive
      :busy="isBusy"
      show-empty
      hover
      thead-class="d-none"
      :borderless="true"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template v-slot:empty>
        <h4>Sie haben noch keine Person eingeladen</h4>
      </template>

      <template v-slot:emptyfiltered>
        <h4>Für diese Suche gibt es keine Resultate</h4>
      </template>

      <template v-slot:cell(invitedDate)="row">
        <span>{{ row.item.invitedDate | moment("DD.MM.YYYY") }}</span>
      </template>

      <template v-slot:cell(inviteState)="row">
        <span v-if="row.item.inviteState === 'INVITED'">Eingeladen</span>
        <span v-else-if="row.item.inviteState === 'ACCEPTED'">Akzeptiert</span>
        <span v-else-if="row.item.inviteState === 'DENIED'">Abgelehnt</span>
        <span v-else></span>
      </template>

      <template v-slot:cell(funktionen)="row">
        <ul class="table-btns">
          <a class="icon-delete" @click="deletePermission(row.item.id)"></a>
        </ul>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      align="right"
      class="my-0"
    ></b-pagination>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      fullname: '',
      email: '',
      username: '',
      invitedDate: '',
      inviteState: '',
      hasUnknownError: false,
      hasError: false,
      errorMessage: '',
      isBusy: false,
      sortBy: 'fullname',
      sortDesc: false,
      fields: [
        { key: 'fullname', label: 'Name', sortable: true },
        { key: 'email', label: 'E-Mail', sortable: true },
        { key: 'invitedDate', label: 'Eingeladen am', sortable: true },
        { key: 'inviteState', label: 'Status', sortable: true },
        { key: 'funktionen', label: '' }
      ],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10
    }),
    created () {
      this.getPermissions()
    },
    methods: {
      async getPermissions () {
        this.isBusy = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('permission/GET_PERMISSIONS', this.applicationId).then(res => {
          this.isBusy = false
          const { errors } = res

          if (errors) {
            this.isBusy = false
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.isBusy = false
          this.hasUnknownError = true
          console.error(err)
        })
      },
      async deletePermission (permissionId) {
        this.$bvModal.msgBoxConfirm('Möchten Sie diese Einladung wirklich löschen?', {
          title: 'Löschen',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Ja',
          cancelTitle: 'Nein',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              this.hasUnknownError = false
              this.hasError = false

              this.$store.dispatch('permission/DELETE_PERMISSION', permissionId).then(res => {
                this.isBusy = false
                const { errors } = res

                if (errors) {
                  return errorHandler(this, errors)
                }
              }).catch(err => {
                this.hasUnknownError = true
                console.error(err)
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
      },
      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    },
    props: {
      applicationId: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters({ items: 'permission/PERMISSIONS' })
    },
    watch: {
      applicationId (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getPermissions()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-col{
    padding-left: 0;
    padding-right: 0;
  }
  .table-btns{
    margin-bottom: 0;
    a {
     line-height: 1;
   }
  }
  .icon-delete, .icon-edit{
    cursor: pointer;
  }
  .status-title{
    border-bottom: 2px solid #6c757d;
    padding-bottom: 0.25rem;
  }
</style>
